
    <div class="app-wrapper mat-app-background">
      <router-outlet></router-outlet>
      <cm-loader #loader></cm-loader>
    </div>
  